<template>
  <font-awesome-icon
    icon="location-dot"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons'

library.add(faMapLocationDot)

export default {
  name: 'CoozzyLocationIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
